export default __webpack_public_path__ + "static/media/flag-en-AU.06fb488a.png";